import { render, staticRenderFns } from "./ClaimCloseModal.vue?vue&type=template&id=21836562&"
import script from "./ClaimCloseModal.vue?vue&type=script&lang=js&"
export * from "./ClaimCloseModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports